import React from 'react';
import './styles.css';
import P from 'prop-types';

export const LoginRodape = ({ handleBodyModal }) => {
  return (
    <div style={{ textAlign: 'center', padding: 20, border: '1px solid #ebebeb' }}>
      Não tem uma conta?
      <a
        href="#"
        onClick={() => handleBodyModal('MEUS_DADOS', 'Cadastro')}
        style={{ color: '#3692e9', cursor: 'pointer', fontWeight: 'bold' }}
      >
        {' '}
        Cadastre-se
      </a>
    </div>
  );
};

LoginRodape.propTypes = {
  handleBodyModal: P.func,
  visibility: P.bool,
};
